import { Component, Injector } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MenuService } from 'src/app/service/MenuService';
import { environment } from 'src/environments/environment';

import { User } from 'src/app/model/user';
import { ContactUsService } from 'src/app/service/ContactUsService';

@Component({
  template: ''
})
export abstract class BaseComponent {

  appError: boolean = false;
  appErrorMessage: string;
  appSuccess: boolean = false;
  appSuccessMessage: string;
  userSession: string;
  isUserSessionActive: boolean = false;
  isSubmitting: boolean = false;
  isCertificatelogin: boolean = false;

  protected get translator(): TranslateService {
    return this.injector.get(TranslateService);
  }

  protected get router(): Router {
    return this.injector.get(Router);
  }

  protected get route(): ActivatedRoute {
    return this.injector.get(ActivatedRoute);
  }

  public get menuService(): MenuService {
    return this.injector.get(MenuService);
  }

  public get contactService(): ContactUsService {
    return this.injector.get(ContactUsService);
  }

  constructor(private injector: Injector) {
    this.route.queryParams.subscribe(params => {
      const lang = (params['lang'])?.trim().toLowerCase() ?? '';
      if (lang === 'en' || lang === 'fr') {
        console.log("found lang in request: " + lang);
        sessionStorage.setItem('currentLang', lang);
        this.translator.use(lang);
      } else {
        var currentLang = sessionStorage.getItem('currentLang');
        console.log("get lang from session: " + currentLang);
        currentLang = (currentLang === 'en' || currentLang === 'fr') ? currentLang : 'en';
        this.translator.use(currentLang);
      }      
    });

    this.userSession = sessionStorage.getItem("user");
    this.contactService.setDisplayStatusByPageType('opsbps');

    if (this.userSession) {
      let user: User = JSON.parse(this.userSession);
      if (user.emailVerified === "false") {
        this.menuService.setDisplayStatusByMenuType('noauth');
        this.isUserSessionActive = true;
      } else if (user.isRoleAdmin === true) {
        this.menuService.setDisplayStatusByMenuType('admin');
        this.isUserSessionActive = true;
      } else {
        this.menuService.setDisplayStatusByMenuType('secure');
        this.isUserSessionActive = true;
      }

      this.isCertificatelogin = (user.pkiuser === "false") ? false : Boolean(user.pkiuser);
    }
    else {
      this.menuService.setDisplayStatusByMenuType('public');
      this.isUserSessionActive = false;
      this.isCertificatelogin = false;
    }
  }

  checkIfAccountLocked(error_code: number) {
    if (error_code === 8 || error_code === 10 || error_code === 11) {
      sessionStorage.removeItem("user");
      sessionStorage.removeItem("resource_url");
      const redirectUrl = environment.getOamLogoutUri() + "?end_url=" + environment.getForgotPasswordUri() + "?error=account_locked";
      window.location.href = redirectUrl;
    }
  }

  getMessage(key: string) {
    if (!key) {
      return this.translator.instant("bss.api.error.default");
    }
    if (key === "bss.api.error.8" || key === "bss.api.error.10" || key === "bss.api.error.11") {
      sessionStorage.removeItem("user");
      sessionStorage.removeItem("resource_url");
      const redirectUrl = environment.getOamLogoutUri() + "?end_url=" + environment.getForgotPasswordUri() + "?error=account_locked";
      window.location.href = redirectUrl;
    } else {
      let message = this.translator.instant(key);
      if (message === key) {
        return this.translator.instant("bss.api.error.default");
      }
      return key;
    }
  }

  processError(error: Error) {
    this.isSubmitting = false;
    this.appError = true;
    this.appErrorMessage = this.getMessage(null);
    this.router.navigate(['public/error', { message: error, refPage: this.router.url }]);
  }

  convertLanguage(user: User) {
    if (user != null) {
      if (user.preferredLanguage.toUpperCase() == "EN" || user.preferredLanguage.toUpperCase() == "ENGLISH") {
        user.preferredLanguage = "en";
      } else {
        user.preferredLanguage == "fr"
      }
    }
  }

  checkRedirectUrl() {
    const resourceUrl = decodeURIComponent(sessionStorage.getItem("resource_url"));
    if ((resourceUrl ?? false) && resourceUrl !== "null") {
      console.log("Redirect URL:" + resourceUrl);
      sessionStorage.removeItem("resource_url");
      window.location.href = resourceUrl;
    } else {
      this.router.navigate(['public/login']);
    }
  }

  validateURL(url: string): boolean {
    const restrictedCharacters = /<|>|\(|\)|script|function|alert/gi;
    return !restrictedCharacters.test(url);
  }
  newSearch(): void {
    // sessionStorage.removeItem("searchUserRole");
    let searchUserRole = sessionStorage.getItem("searchUserRole");
    if (searchUserRole != null) {
      let searchUserRoleObj = JSON.parse(searchUserRole);
      searchUserRoleObj.user = {};
      let updatedSearchUserRole = JSON.stringify(searchUserRoleObj);
      sessionStorage.setItem('searchUserRole', updatedSearchUserRole);
    }
    this.router.navigate(['secure/paadmin/role/search']);
  }

}